import React from "react";
import { ActionButton } from "../../../../../../../Common/Buttons/ActionButton";
import TextInput from "../../../../../../../Inputs/Text";
import {
  ActionButtonContainer,
  InputContainer,
  LabelContainer,
  LVLabel,
  OptionsContainer,
} from "../__styles__/WidgetSettings";

type LabelValueOptionsProps = {
  options: Array<{
    label: string;
    value: string;
  }>;
  updateOption: (index: number, label: string, value: string) => void;
  deleteOption: (index: number) => void;
  valueEditingDisabled?: boolean;
  disabled: boolean;
};

export function LabelValueOptionsInput({
  options,
  updateOption,
  deleteOption,
  valueEditingDisabled = false,
  disabled,
}: LabelValueOptionsProps) {
  return (
    <div data-testid="label-value-options-input-wrapper">
      <LabelContainer>
        <LVLabel text="Label" />
        <LVLabel text="Value" />
      </LabelContainer>
      {options.map((option, index) => (
        <OptionsContainer key={`option.${index}`}>
          <InputContainer>
            <TextInput
              onChange={label =>
                updateOption(
                  index,
                  label,
                  valueEditingDisabled ? option.value : label,
                )
              }
              name={`label.${index}`}
              value={option.label}
              disabled={disabled}
            />
          </InputContainer>
          <TextInput
            name={`value.${index}`}
            disabled={!option.label || valueEditingDisabled || disabled}
            value={option.value}
            onChange={value => updateOption(index, option.label, value)}
          />
          <ActionButtonContainer hidden={options.length === 1 || disabled}>
            <ActionButton icon="x" onClick={() => deleteOption(index)} />
          </ActionButtonContainer>
        </OptionsContainer>
      ))}
    </div>
  );
}
